// extracted by mini-css-extract-plugin
export default {"title":"ActiveAndInActiveControl_title__DuhSx"};